interface ICompositeTemplates {
  template_id: number;
  images: {
    id: string;
    url: string;
    originalPhoto: string;
    modified_metadata?: string;
  }[];
  selected: boolean;
}
export interface IComposite {
  templates?: ICompositeTemplates[];
  enabled?: boolean;
  info?: Array<{
    key: string;
    value: string;
  }>;
}

export const INITIAL_COMPOSITE_STATES: IComposite = {
  info: [],
  enabled: false,
  templates: [
    {
      template_id: 1,
      images: [
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
      ],
      selected: true,
    },
    {
      template_id: 2,
      images: [
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
      ],
      selected: false,
    },
    {
      template_id: 3,
      images: [
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
      ],
      selected: false,
    },
    {
      template_id: 4,
      images: [
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
        { id: '', url: '', originalPhoto: '' },
      ],
      selected: false,
    },
  ],
};
